export default class LanguageDropdown {
  static init () {
    const languageDropdown = document.getElementById('language-dropdown')

    if (languageDropdown) {
      languageDropdown.addEventListener('mouseleave', () => {
        setTimeout(() => {
          const dropdownMenu = languageDropdown.getElementsByClassName('dropdown-menu')[0]

          if (dropdownMenu.classList.contains('open')) {
            dropdownMenu.classList.remove('open')
            languageDropdown.classList.remove('open')
          }
        }, 3000)
      })

      languageDropdown.addEventListener('click', () => {
        const dropdownMenu = languageDropdown.getElementsByClassName('dropdown-menu')[0]

        if (dropdownMenu.classList.contains('open')) {
          dropdownMenu.classList.remove('open')
          languageDropdown.classList.remove('open')
        }
        else {
          dropdownMenu.classList.add('open')
          languageDropdown.classList.add('open')
        }
      })
    }
  }
}
